module.exports = __webpack_public_path__ + "static/media/9.a1e8dea0.svg";